<template>
  <div class="w-full h-full flex flex-col gap-[20px]"
    v-if="llmStore.results[currentTaskId] && Object.keys(results).length">
    <el-scrollbar @scroll="handleScroll" ref="resultsWrapperRef"
      class="flex-grow flex flex-col gap-[20px] box-border px-[5px] pl-[0px]">
      <TransitionGroup name="list" tag="div" class="flex flex-col gap-[20px] h-full px-[5px]">
        <div ref="innerRef">
          <div v-for="(item, index) in resultsSorted" :key="item.parent_key" class="flex mb-[10px] flex-col gap-[20px]">
            <div class="flex gap-[20px]" v-if="results[item.parent_key]">
              <div :class="[
      'flex-col flex gap-[10px] bg-[#fff] rounded-[10px] p-[20px] pb-[20px]  shadow w-full break-all',
      {
        error: generateObjStatus[item.parent_key] === '生成失败'
      }
    ]">
                <InspStreamHandler :index="index" :taskDetail="item" :key="item.parent_key"
                  @watchGenerateStatus="watchGenerateStatus" @refresh="refresh" />
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </el-scrollbar>

    <div class="w-full flex justify-center">
      <el-button type="primary" size="default" @click="getMoreInspiration" color="#6a50fd"
        :loading="oneMoreLoading">再来一条</el-button>
    </div>
  </div>
</template>

<script setup>
import { useTaskStore } from '../../store/taskStore'
import { useLLMStore } from '../../store/llm'
import { computed, toRefs, ref, nextTick, reactive, watchEffect, onMounted } from 'vue'
import { ElMessage, ElButton } from 'element-plus'
import { modeEnum } from '../../utils/enums'
import { getGenerated, getTaskDetail } from '@service/task';
import { eventTrackingFunc } from '../../utils/utils'

const resultRefs = ref({})
const taskStore = useTaskStore()
const llmStore = useLLMStore()
// 动态ref
// const setItemRef = (el: any, idx: any) => {

//   if (el) {
//     resultRefs.value[idx] = el
//   }
//   console.log(el, resultRefs, '--xxxxx->')
// }
const currentTaskId = computed(() => taskStore.currentTaskDetail.id)
const allTotal = computed(() => taskStore.allTotal)
const results = computed(() => {
  const newObj = {}
  Object.keys(llmStore.results[currentTaskId.value]).forEach((key) => {
    if (key.startsWith('insp_')) {
      newObj[key] = llmStore.results[currentTaskId.value][key]
    }
  })
  return newObj
})

const state = reactive({
  page: 1,  // 当前页
  pageSize: 10,  // 每页显示条数
  total: 0,  // 总条数
  loading: false,  // 加载状态
  list: []  // 数据列表
})

const resultsSorted = computed(() => {
  if (!Object.keys(results.value).length) return []
  const sortedKeys = Object.keys(results.value)
    .map((key) => {
      return {
        parent_key: key,
        number: key.split('_')[1],
        event: results.value[key].event,
        evaluate: results.value[key].evaluate,
        ...results.value[key],
        taskId: results.value[key].parent_id,
        id: results.value[key].id
      }
    })
    .sort((a, b) => b.number - a.number)
  return sortedKeys
})

const maxKey = computed(() => {
  const maxKeyAddOne = allTotal.value + 1
  taskStore.$patch((state) => {
    state.allTotal = allTotal.value + 1
  })
  return `insp_${maxKeyAddOne}`
})

const generateObjStatus = reactive({})

const watchGenerateStatus = ({ key, status }) => {
  generateObjStatus[key] = status
}

const oneMoreLoading = ref(false)
const resultsWrapperRef = ref(null)
const getMoreInspiration = async () => {
  try {
    oneMoreLoading.value = true
    nextTick(() => {
      if (resultsWrapperRef.value) {
        resultsWrapperRef.value.scrollTop = 0
      }
    })
    await taskStore.generateTask({
      variables: taskStore.variables,
      keys: [maxKey.value],
      llm_type: modeEnum[taskStore.currentTaskDetail.content.script_mode],
      task_id: currentTaskId.value,
      industry_id: taskStore.currentTaskDetail.industry_id,
    })
    // 埋点
    const eventTrackingParmas = {
      customized_id: currentTaskId.value + '',
      event_name: 'GenerateAppend',
      event_type: 'Click',
      event_time: 0,
      page_name: '',
    }
    eventTrackingFunc(eventTrackingParmas)
    oneMoreLoading.value = false
  } catch (error) {
    ElMessage.error(error.message)
  }
}
// 刷新页面
const refresh = async (childVal) => {
  // await taskStore.initializeTaskDetail(childVal.taskId)
  // await taskStore.handleGeneratedContent()
  llmStore.$patch((state) => {
    state.results[childVal.taskId][childVal.parentKey.value].evaluate = childVal.val
  })
}
// 更新滚动条位置
const updateScroll = () => {
}

const items = ref([]);
const loading = ref(false);

const fetchData = async () => {
  state.page++
  const { data: { generated_content } } = await getGenerated(currentTaskId.value, { page: state.page })
  const { code: detailCode, data: taskDetail } = await getTaskDetail(currentTaskId.value)

  loading.value = false;
  const moreArray = generated_content.reduce((acc, item) => {
    acc[item.parent_key] = {
      ...item,
      generateStatus: '生成完毕'
    }
    acc.tasks_generated = true // 任务已经生成完毕
    return acc
  }, {})
  llmStore.$patch((state) => {
    state.results[currentTaskId.value] = { ...state.results[currentTaskId.value], ...moreArray }
  })

  // 更新 taskStore 中的 currentTaskDetail
  if (detailCode === 0) {
    taskStore.appendGeneratedContentAndUpdateTask(generated_content, taskDetail)
  } else {
    ElMessage.error('获取任务详情失败')
  }
};

const innerRef = ref(null)

const handleScroll = ({ scrollTop }) => {
  const scrollContainer = resultsWrapperRef.value.$el.querySelector('.el-scrollbar__wrap');
  const height = scrollContainer.clientHeight;
  if (scrollTop + height >= innerRef.value.clientHeight) {
    console.log('到底了')
    if (!loading.value) {
      loading.value = true;
      fetchData();
    }
  }
};

watchEffect(() => {
  const values = Object.values(generateObjStatus)
  const tasks_generated = llmStore.results[currentTaskId.value]?.tasks_generated
  if (
    values.length &&
    values.every((status) => status === '生成完毕') &&
    tasks_generated &&
    taskStore.rawTasks[currentTaskId.value].status !== '生成完毕-用户已读'
  ) {
    taskStore.handleTaskRead(currentTaskId.value)
  }
})
onMounted(() => {
  // getResult()
  // getResultsSorted()
})

const { page, pagesize } = toRefs(state)

</script>

<style lang="scss" scoped></style>
